/**
 * Created by yqr on 2019/2/20.
 */
import Env from "./env";
import * as API from "./";
//基地址
let base = Env.baseURL;
export default {
    //上传附件
    uploadFile: () => {
        return `${base}/handle/platformAttachment/upload`;data
    },
    //上传脚本
    uploadAnalysis: () => {
        return `${base}/handle/platformAttachment/upload/analysis`;
    },
    //下载文件
    download: id => {
        return `${base}/handle/platformAttachment/download?fileId=${id}`;
    },
    //品牌型号级联数据
    platformMduProtocolBrandAndModel: params => {
        return API.GET("/handle/v1/platformMduProtocol/brandAndModel", params);
    },
    //获取网关信息列表(网关信息同接口)
    platformMduModulePage: params => {
        return API.GET("/handle/v1/platformMduModule/page", params);
    },
    // 查询下发指令列表
    platformAutoCmde: params => {
        return API.GET("/handle/v1/platformMduModule/autoCmd", params);
    },

    platformMduModuleLog: params => {
        return API.GET("/handle/v1/platformMduModule/log", params);
    },

    //导出日志
    exportMduModuleLogUrl: params => {
        return (
            `${base}/handle/v1/platformMduModule/exportLog?` +
            Object.keys(params)
            .map(key => key + "=" + encodeURIComponent(params[key]))
            .join("&")
        );
    },
    //导出网关列表
    exportModuleUrl: params => {
        return (
            `${base}/handle/v1/platformMduModule/exportList?` +
            Object.keys(params)
            .map(key => key + "=" + encodeURIComponent(params[key]))
            .join("&")
        );
    },
    //删除网关
    delPlatformMduModule: params => {
        return API.POSTFLAG("/handle/v1/platformMduModule/del", params);
    },
    //新增网关
    addPlatformMduModule: params => {
        return API.POST("/handle/v1/platformMduModule", params);
    },
    //重置网关密钥
    resetMduEncrypt: params => {
        return API.POST("/handle/v1/platformMduModule/resetEncrypt", params);
    },
    //修改网关
    editPlatformMduModule: (id, params) => {
        return API.PUT(`/handle/v1/platformMduModule/${id}`, params);
    },
    //获取网关配置信息
    platformMduModuleGatewayConfig: id => {
        return API.GET(`/handle/v1/platformMduModule/gatewayConfig/${id}`);
    },
    //获取新增网关页面的所有数据
    platformMduModuleAddData: params => {
        return API.GET("/handle/v1/platformMduModule/add/data", params);
    },
    //根据品牌获取型号的下拉数据
    platformMduModuleModelList: id => {
        return API.GET(`/handle/v1/platformMduModule/modelList/${id}`);
    },
    //根据品牌,型号 获取推荐协议的数据
    platformMduModuleModuleProtocol: (brandId, modelId) => {
        return API.GET(
            `/handle/v1/platformMduModule/moduleProtocol/${brandId}/${modelId}`
        );
    },
    //查找网关协议
    platformMduModuleModuleProtocolList: params => {
        return API.GET("/handle/v1/platformMduModule/moduleProtocol", params);
    },
    //获取网关详情
    platformMduModule: id => {
        return API.GET(`/handle/v1/platformMduModule/${id}`);
    },
    //根据网关查找设备
    platformMduModuleDevice: id => {
        return API.GET(`/handle/v1/platformMduModule/device/${id}`);
    },
    //根据网关查找网关协议
    platformMduModuleModuleProtocolID: id => {
        return API.GET(`/handle/v1/platformMduModule/moduleProtocol/${id}`);
    },
    //私有协议分页数据查询
    platformMduProtocolSelfPage: params => {
        return API.GET("/handle/v1/platformMduProtocol/self/page", params);
    },
    //导出网关协议
    exportMduProtocolUrl: id => {
        return `${base}/handle/v1/platformMduProtocol/export?id=` + id;
    },
    //导入网关协议
    importMduProtocolUrl: () => {
        return `${base}/handle/v1/platformMduProtocol/import`;
    },
    //删除私有网关协议
    delPlatformMduProtocolPrivate: params => {
        return API.DELETE("/handle/v1/platformMduProtocol/private", params);
    },
    //删除公有网关协议
    delPlatformMduProtocolCommon: params => {
        return API.DELETE("/handle/v1/platformMduProtocol/common", params);
    },
    //新增私有网关协议
    addPlatformMduProtocolPrivate: params => {
        return API.POST("/handle/v1/platformMduProtocol/private/add", params);
    },
    //新增公有网关协议
    addPlatformMduProtocolCommon: params => {
        return API.POST("/handle/v1/platformMduProtocol/common/add", params);
    },
    //修改私有协议
    editPrivatePlatformMduProtocol: (id, params) => {
        return API.PUT(`/handle/v1/platformMduProtocol/private/${id}`, params);
    },
    //修改私有协议
    editCommonPlatformMduProtocol: (id, params) => {
        return API.PUT(`/handle/v1/platformMduProtocol/common/${id}`, params);
    },
    //升级网关协议为平台协议
    upgradePlatformMduProtocol: (id, params) => {
        return API.PUT(`/handle/v1/platformMduProtocol/upgrade/${id}`, params);
    },
    //获取协议推荐端口
    getPort: params => {
        return API.GET("/handle/v1/platformMduProtocol/getPort", params);
    },
    //获取服务器IP
    getServerIP: params => {
        return API.GET("/handle/v1/platformMduProtocol/getServerIp", params);
    },
    //获取字典默认的端口
    getDefaultPort: params => {
        return API.GET("/handle/v1/platformMduProtocol/getDefaultPort", params);
    },
    //获取协议详情
    platformMduProtocol: id => {
        return API.GET(`/handle/v1/platformMduProtocol/${id}`);
    },
    //根据协议获取品牌型号
    platformMduProtocolBrandModel: id => {
        return API.GET(`/handle/v1/platformMduProtocol/brand/model/${id}`);
    },
    //根据协议获取所连网关
    platformMduProtocolModule: id => {
        return API.GET(`/handle/v1/platformMduProtocol/module/${id}`);
    },
    //获取可转移设备列表
    transferableDevicePage: params => {
        return API.GET(
            "/handle/v1/platformMduModule/transferableDevicePage",
            params
        );
    },
    //转移设备
    transferDev: params => {
        return API.POST("/handle/v1/platformMduModule/transferDev", params);
    },
    //获取设备信息
    platformDevDevicePage: params => {
        return API.GET("/handle/platformDevDevice/page", params);
    },
    //获取设备列表
    platformGetYsDeviceListUnRef: params => {
        return API.GET("/handle/platformDevDevice/getYsDeviceListUnRef", params);
    },
    //新增设备信息
    addPlatformDevDevice: params => {
        return API.POST("/handle/platformDevDevice/add", params);
    },
    //删除设备
    delPlatformDevDevice: params => {
        return API.POSTFLAG("/handle/platformDevDevice/del", params);
    },
    //修改设备
    editPlatformDevDevice: (id, params) => {
        return API.PUT(`/handle/platformDevDevice/${id}`, params);
    },
    //查看设备
    platformDevDeviceView: id => {
        return API.GET(`/handle/platformDevDevice/view/${id}`);
    },
    //同步采集任务
    synchronousTask: params => {
        return API.POST("/handle/platformDevDevice/synchronousTask", params);
    },
    //获取设备地理位置列表
    getDevicePosition: params => {
        return API.GET("/handle/platformDevDevice/getDevicePosition", params);
    },
    //物影子
    platformDevDeviceGetrealtimedata: params => {
        return API.GET("/handle/platformDevDevice/getrealtimedata", params);
    },
    //查看历史数据
    platformDevDeviceDatelinedata: params => {
        return API.GET("/handle/platformDevDevice/datelinedata", params);
    },
    //根据包ID查询包字段
    platformDevDevicePackFeilds: params => {
        return API.GET("/handle/platformDevDevice/packFeilds", params);
    },
    //远程控制执行
    tcpctrlfun: params => {
        return API.POSTFLAG("/handle/platformDevDevice/tcpctrlfun", params);
    },
    //根据设备获取设备协议
    platformDevProtocolView: id => {
        return API.GET(`/handle/platformDevProtocol/view/${id}`);
    },
    //查看设备实时数据
    platformDevDeviceTelecontrol: id => {
        return API.GET(`/handle/platformDevDevice/telecontrol/${id}`);
    },
    //获取设备统计信息
    platformDevDeviceStatistics: params => {
        return API.GET("/handle/platformDevDevice/statistics", params);
    },
    //获取模主/网关信息
    platformDevDeviceModule: params => {
        return API.GET("/handle/platformDevDevice/module", params);
    },
    //获取北向连接方式
    platformDevDeviceLinkTypeArray: params => {
        return API.GET("/handle/platformDevDevice/linkTypeArray", params);
    },
    //获取设备品牌
    platformDevDeviceBrand: params => {
        return API.GET("/handle/platformDevDevice/brand", params);
    },
    //根据设备品牌获取设备型号
    platformDevDeviceModel: params => {
        return API.GET("/handle/platformDevDevice/model", params);
    },
    //根据设备品牌,设备型号获取推荐协议
    platformDevDeviceRecommendProtocol: params => {
        return API.GET("/handle/platformDevDevice/recommendProtocol", params);
    },
    //获取所有设备协议
    platformDevDeviceProtocol: params => {
        return API.GET("/handle/platformDevDevice/protocol", params);
    },
    //设备历史指令
    platformDevManualCmd: params => {
        return API.GET("/handle/platformDevDevice/manualCmd", params);
    },
    //获取设备分类树形数据
    platformDevCategoryDevCategoryList: params => {
        return API.GET("/handle/v1/platformDevCategory/devCategory/list", params);
    },
    //获取设备分类详情
    platformDevCategory: id => {
        return API.GET(`/handle/v1/platformDevCategory/${id}`);
    },
    //新增设备分类
    addPlatformDevCategory: params => {
        return API.POST("/handle/v1/platformDevCategory", params);
    },
    //删除设备分类
    delplatformDevCategory: id => {
        return API.DELETE(`/handle/v1/platformDevCategory/${id}`);
    },
    //修改分类
    editPlatformDevCategory: (id, params) => {
        return API.PUT(`/handle/v1/platformDevCategory/${id}`, params);
    },
    //设备私有协议分页数据查询
    platformDevProtocolSelfPage: params => {
        return API.GET("/handle/platformDevProtocol/self/page", params);
    },
    //设备所有协议分页数据查询
    platformDevProtocolPage: params => {
        return API.GET("/handle/platformDevProtocol/page", params);
    },

    //导入设备协议
    importDevProtocolUrl: () => {
        return `${base}/handle/platformDevProtocol/import`;
    },
    //导出设备协议
    exportDevProtocolUrl: id => {
        return `${base}/handle/platformDevProtocol/export?id=` + id;
    },
    //创建私有设备协议
    addplatformDevProtocolPrivate: params => {
        return API.POST("/handle/platformDevProtocol/private/add", params);
    },
    //创建公有设备协议
    addplatformDevProtocolCommon: params => {
        return API.POST("/handle/platformDevProtocol/common/add", params);
    },
    //获取设备品牌型号级联数据
    platformDevProtocolBrandAndModel: params => {
        return API.GET("/handle/platformDevProtocol/brandAndModel", params);
    },
    //创建私有包体名称
    platformDevProtocolPacketPrivate: params => {
        return API.POST("/handle/platformDevProtocol/private/packet", params);
    },
    //创建公有包体名称
    platformDevProtocolPacketCommon: params => {
        return API.POST("/handle/platformDevProtocol/common/packet", params);
    },
    //完成私有创建上下行包体
    platformDevProtocolPacketFieldPrivate: params => {
        return API.POSTFLAG(
            "/handle/platformDevProtocol/private/packetField",
            params
        );
    },
    //完成公有创建上下行包体
    platformDevProtocolPacketFieldCommon: params => {
        return API.POSTFLAG(
            "/handle/platformDevProtocol/common/packetField",
            params
        );
    },
    //获取上下行包体详情
    platformDevProtocolViewPacket: id => {
        return API.GET(`/handle/platformDevProtocol/view/packet/${id}`);
    },
    //修改私有包体属性
    editPlatformDevProtocolPacketPrivate: (id, params) => {
        return API.PUT(`/handle/platformDevProtocol/private/packet/${id}`, params);
    },
    //修改公有包体属性
    editPlatformDevProtocolPacketCommon: (id, params) => {
        return API.PUT(`/handle/platformDevProtocol/common/packet/${id}`, params);
    },
    //查看设备协议详情
    platformDevProtocolViewDetails: id => {
        return API.GET(`/handle/platformDevProtocol/view/details/${id}`);
    },
    //查看上下行包详情
    platformDevProtocolViewPacketAndField: (id, type) => {
        return API.GET(
            `/handle/platformDevProtocol/view/packetAndField/${id}/${type}`
        );
    },
    //根据设备协议获取品牌型号详情
    platformDevProtocolBrandModel: id => {
        return API.GET(`/handle/platformDevProtocol/brand/model/${id}`);
    },
    //根据设备协议获取已连接设备
    platformDevProtocolDeviceList: id => {
        return API.GET(`/handle/platformDevProtocol/deviceList/${id}`);
    },
    //删除私有设备协议
    delPlatformDevProtocolDeviceProtocolPrivate: params => {
        return API.DELETE(
            "/handle/platformDevProtocol/private/deviceProtocol",
            params
        );
    },
    //删除公有设备协议
    delPlatformDevProtocolDeviceProtocolCommon: params => {
        return API.DELETE(
            "/handle/platformDevProtocol/common/deviceProtocol",
            params
        );
    },
    //查看修改设备协议详情
    platformDevProtocolUpdateDetails: id => {
        return API.GET(`/handle/platformDevProtocol/update/details/${id}`);
    },
    //修改私有设备协议
    editPrivatePlatformDevProtocol: (id, params) => {
        return API.PUT(`/handle/platformDevProtocol/private/${id}`, params);
    },
    //修改公有设备协议
    editCommonPlatformDevProtocol: (id, params) => {
        return API.PUT(`/handle/platformDevProtocol/common/${id}`, params);
    },
    //提升设备协议为平台协议
    upgradePlatformDevProtocol: (id, params) => {
        return API.PUT(`/handle/platformDevProtocol/upgrade/${id}`, params);
    },
    //删除私有设备协议包体
    delPlatformDevProtocolDeviceProtocolPacketPrivate: params => {
        return API.DELETE(
            "/handle/platformDevProtocol/private/deviceProtocol/packet",
            params
        );
    },
    //删除公有设备协议包体
    delPlatformDevProtocolDeviceProtocolPacketCommon: params => {
        return API.DELETE(
            "/handle/platformDevProtocol/common/deviceProtocol/packet",
            params
        );
    },
    //修改私有上行包数据
    editPlatformDevProtocolPacketFieldPrivate: params => {
        return API.PUTFLAG(
            "/handle/platformDevProtocol/private/packetField",
            params
        );
    },
    //修改公有上行包数据
    editPlatformDevProtocolPacketFieldCommon: params => {
        return API.PUTFLAG(
            "/handle/platformDevProtocol/common/packetField",
            params
        );
    },
    //获取策略信息分页
    platformRuleStrategyPage: params => {
        return API.GET("/handle/platformRuleStrategy/page", params);
    },
    //新增策略
    addPlatformRuleStrategy: params => {
        return API.POST("/handle/platformRuleStrategy", params);
    },
    //删除策略
    delPlatformRuleStrategy: params => {
        return API.DELETE("/handle/platformRuleStrategy", params);
    },
    //策略详情
    platformRuleStrategy: id => {
        return API.GET(`/handle/platformRuleStrategy/${id}`);
    },
    //修改策略
    editPlatformRuleStrategy: (id, params) => {
        return API.PUT(`/handle/platformRuleStrategy/${id}`, params);
    },
    //获取规则列表
    platformRuleEnginePage: params => {
        return API.GET("/handle/platformRuleEngine/page", params);
    },
    //修改规则
    editplatformRuleEngine: (id, params) => {
        return API.PUT(`/handle/platformRuleEngine/${id}`, params);
    },
    //新增规则
    addPlatformRuleEngine: params => {
        return API.POST("/handle/platformRuleEngine", params);
    },
    //删除规则
    delPlatformRuleEngine: params => {
        return API.DELETE("/handle/platformRuleEngine", params);
    },
    //查看规则详情
    platformRuleEngine: id => {
        return API.GET(`/handle/platformRuleEngine/${id}`);
    },
    //新增规则细节
    addPlatformRuleEngineDetail: params => {
        return API.POSTFLAG("/handle/platformRuleEngine/detail", params);
    },
    //查询规则细节
    PlatformRuleEngineDetail: id => {
        return API.GET(`/handle/platformRuleEngine/detail/${id}`);
    },
    //修改规则细节
    editPlatformRuleEngineDetailUpdate: params => {
        return API.POSTFLAG("/handle/platformRuleEngine/detail/update", params);
    },
    //根据设备id获取包体字段
    platformDevProtocolPacketFieldPacketField: id => {
        return API.GET(
            `/handle/platformDevProtocolPacketField/packetField/devId/${id}`
        );
    },
    //根据设备id查询包体
    platformDevProtocolPacketPacket: id => {
        return API.GET(`/handle/platformDevProtocolPacket/packet/${id}`);
    },
    //根据包体id查包体字段
    platformDevProtocolPacketFieldPacketFieldPacketId: id => {
        return API.GET(
            `/handle/platformDevProtocolPacketField/packetField/packetId/${id}`
        );
    },
    // 告警中心
    // 告警列表
    //获取告警列表
    platformAlarmList: params => {
        return API.GET("/handle/platformAlarm/page", params);
    },
    //获取告警配置列表
    platformAlarmConfigList: params => {
        return API.GET("/handle/platformAlarmConfig/page", params);
    },
    //切换启动/停止
    platformAlarmConfigSwitch: (id, params) => {
        return API.PUT(`/handle/platformAlarmConfig/switch/${id}`, params);
    },
    //删除告警配置
    delplatformAlarmConfig: params => {
        return API.DELETE("/handle/platformAlarmConfig", params);
    },
    //新增告警配置
    platformAlarmConfigAdd: params => {
        return API.POST("/handle/platformAlarmConfig", params);
    },
    //修改告警配置
    platformAlarmConfigEdit: (id, params) => {
        return API.PUT(`/handle/platformAlarmConfig/${id}`, params);
    },
    //获取所有规则
    platformRuleConfigList: params => {
        return API.GET("/handle/platformRuleEngine/getAllRule", params);
    },
    //告警配置详情
    platformAlarmConfigDet: id => {
        return API.GET(`/handle/platformAlarmConfig/${id}`);
    },
    //调试中心
    //设备调试连接
    platformDevDebugConnect: params => {
        return API.POST("/handle/platformDevDebug/platformDevDebugConnect", params);
    },
    //设备调试报文发送
    sendDebugMessage: params => {
        return API.POST("/handle/platformDevDebug/sendDebugMessage", params);
    },
    //关闭设备调试连接
    disconnectDebug: params => {
        return API.POST("/handle/platformDevDebug/disconnectDebug", params);
    },
    //脚本测试接口
    groovyDebug: params => {
        return API.POST(`/exegroovy/groovy/executedebug/`, params);
    },

    //获取企业申请列表
    enterprisePage: params => {
        return API.GET("/handle/platformIntroductionEnterprise/page", params);
    },

    //获取用户列表
    userPage: params => {
        return API.GET("/handle/sysUser/page", params);
    },

    //新增用户
    addSysUser: params => {
        return API.POST("/handle/sysUser", params);
    },
    //修改用户
    editSysUser: params => {
        return API.PUT("/handle/sysUser", params);
    },
    //删除用户
    delSysUser: params => {
        return API.DELETE("/handle/sysUser", params);
    },
    //查看用户详情
    userView: id => {
        return API.GET(`/handle/sysUser/view/${id}`);
    },
    //修改用户密码
    changePwd: params => {
        return API.POST("/handle/sysUser/changePwd", params);
    },
     //超管修改其他用户密码
     superChangePwd: params => {
       return API.POST("/handle/sysUser/superChangePwd", params);
     },
    //获取角色列表
    rolePage: params => {
        return API.GET("/handle/sysRole/page", params);
    },
    //通过角色id获取已授权菜单id集合
    sysRolePermissionSelectMenuId: params => {
        return API.GET("/handle/sysRolePermission/select/menuId", params);
    },
    //新增角色
    addSysRole: params => {
        return API.POSTFLAG("/handle/sysRole", params);
    },
    //修改角色
    editSysRole: params => {
        return API.PUTFLAG("/handle/sysRole", params);
    },
    //删除角色
    delRole: params => {
        return API.DELETE("/handle/sysRole", params);
    },

    //获取第三方授权列表
    oauthClientPage: params => {
        return API.GET("/handle/oauthClientDetails/page", params);
    },
    //新增第三方授权条目
    addOauthClient: params => {
        return API.POSTFLAG("/handle/oauthClientDetails", params);
    },
    //修改第三方授权条目
    editOauthClient: params => {
        return API.PUTFLAG("/handle/oauthClientDetails", params);
    },
    //删除第三方授权条目
    delOauthClient: params => {
        return API.DELETE("/handle/oauthClientDetails", params);
    },
    //获取菜单列表
    sysMenuPermissionList: params => {
        return API.GET("/handle/sysMenuPermission/list", params);
    },
    //新增菜单
    addSysMenuPermission: params => {
        return API.POST("/handle/sysMenuPermission", params);
    },
    //删除菜单
    delSysMenuPermission: params => {
        return API.DELETE("/handle/sysMenuPermission", params);
    },
    //萤石云账号管理
    ysAccountList: params => {
        return API.GET("/handle/ysAccount/getPage", params);
    },
    //萤石云详情
    ysAccountGetById: params => {
        return API.GET("/handle/ysAccount/getById", params);
    },
    //萤石云账号新增
    ysAccountSave: params => {
        return API.POST("/handle/ysAccount/save", params);
    },
    //根据萤石id查询关联的设备列表
    saveYsTokenDevice: params => {
        return API.POST("/handle/ysAccount/saveYsTokenDevice", params);
    },
    //根据设备id查询萤石云视频播放rtmp地址
    getYSPlayUrl: params => {
        return API.GET("/handle/ysAccount/getYSPlayUrl", params);
    },
    //根据萤石id查询关联的设备列表
    getDevsByYsTokenId: params => {
        return API.GET("/handle/ysAccount/getDevsByYsTokenId", params);
    },
    //*******************推送服务********************** */
    //推送服务列表
    pushServiceList: params => {
        return API.GET("/handle/platformPushService/getPage", params);
    },
    //推送服务详情
    pushServiceGetById: params => {
        return API.GET("/handle/platformPushService/getById", params);
    },
    //推送服务新增
    pushServiceSave: params => {
        return API.POST("/handle/platformPushService/save", params);
    },
    //删除推送服务
    delPushService: params => {
        return API.DELETE("/handle/platformPushService/delete", params);
    },
    /******dashboard */
    //获取网关下拉列表
    ModuleDropdownlist: params => {
        return API.GET(`/handle/v1/platformMduModule/dropdownlist/`, params);
    },
    //获取设备下拉列表
    DeviceDropdownlist: params => {
        return API.GET(`/handle/platformDevDevice/dropdownlist/`, params);
    },
    //获取设备状态情况
    DashboardDeviceStatistics: params => {
        return API.GET(`/handle/dashboard/deviceStatistics/`, params);
    },
    //获取网关数量情况
    DashboardModuleStatistics: params => {
        return API.GET(`/handle/dashboard/moduleStatistics/`, params);
    },
    //获取设备分类统计
    deviceCommuTypeStatistics: params => {
        return API.GET(`/handle/dashboard/deviceCommuTypeStatistics/`, params);
    },
    //获取网关分类统计
    moduleCommuTypeStatistics: params => {
        return API.GET(`/handle/dashboard/moduleCommuTypeStatistics/`, params);
    },
    //获取在线详情
    DashboardOnlineDetail: params => {
        return API.GET(`/handle/dashboard/onlineDetail/`, params);
    },
    //获取历史在线率
    DeviceOnlineRate: params => {
        return API.GET(`/handle/dashboard/onlineRateStatistics/`, params);
    },
    /******dashboard */

    //字典数据
    listDictionary: params => {
        return API.GET(`/handle/platformDictionary/page`, params);
    },

    treeDictionary: params => {
        return API.GET(`/handle/platformDictionary/tree`, params);
    },

    addDictionary: params => {
        return API.POST(`/handle/platformDictionary/add`, params);
    },

    updateDictionary: params => {
        return API.PUT(`/handle/platformDictionary/update`, params);
    },

    delDictionary: params => {
        return API.DELETE(`/handle/platformDictionary/delete`, params);
    },
    //根据TypeCode查询字典
    getDictionaryListByCode: params => {
        return API.GET(`/handle/platformDictionary/getListByCode`, params);
    },

    //策略禁用、启用
    platformRuleStrategyStop: params => {
        return API.PUT("/handle/platformRuleStrategy/stop", params);
    },

    exportDeviceUrl: params => {
        return (
            `${base}/handle/platformDevDevice/export?` +
            Object.keys(params)
            .map(key => key + "=" + encodeURIComponent(params[key]))
            .join("&")
        );
    },

    exportDeviceHistoryDataUrl: params => {
        return (
            `${base}/handle/platformDevDevice/exportDeviceHistoryData?` +
            Object.keys(params)
            .map(key => key + "=" + encodeURIComponent(params[key]))
            .join("&")
        );
    },

    disableSysUser: params => {
        return API.POST("/handle/sysUser/enable", params);
    },

    //api统计
    getApiVisitStatistics: params => {
        return API.GET(`/handle/apiVisitStatistics/getApiVisitStatistics`, params);
    },

    /*===============================================start 产品管理 =========================*/
    //获取产品信息列表
    platformProductPage: params => {
        return API.GET("/handle/v1/platformProduct/page", params);
    },
    //根据id获取产品详情
    platformProductView: id => {
        return API.GET(`/handle/v1/platformProduct/view/${id}`);
    },
    //添加产品
    platformProductAdd: params => {
        return API.POST("/handle/v1/platformProduct/add", params);
    },
    //编辑产品
    platformProductEdit: (id, params) => {
        return API.PUT(`/handle/v1/platformProduct/edit/${id}`, params);
    },

    //编辑产品
    platformProductDelete: id => {
        return API.DELETE(`/handle/v1/platformProduct/del/${id}`);
    },
    /*===============================================end 产品管理 =========================*/

    /*===============================================start 系统运行日志 =========================*/
    // 查列表接口 /app/pushMessage/list 
    platformPushLogList:params=>{
          return API.GET("/handle/platformPushLog/list",params)
    },
    // 查详情platformPushLog/{id}
    platformPushLogDetail:id=>{
        return API.GET(`/handle/platformPushLog/${id}`);
    },
    // 规则日志查询接口
    platformRuleLogList:params=>{
        return API.GET("/handle/platformRuleLog/list",params)
    },
    // 规则日志详情接口
    platformRuleLogDetail:id=>{
        return API.GET(`/handle/platformRuleLog/${id}`)
    },
    // 操作日志查询接口
    operateLogList: params => {
      return API.GET("/handle/monitor/operlog/list", params)
    },
    // 操作日志删除接口
    delOperlog: ids => {
        return API.DELETE("/handle/monitor/operlog/" + ids)
    },
    // 操作日志清空接口
    cleanOperlog: params => {
        return API.DELETE("/handle/monitor/operlog/clean")
    },
    // 登录日志查询接口
    loginLogList: params => {
      return API.GET("/handle/monitor/logininfor/list", params)
    },
    // 登录日志删除接口
    delLogininfor: ids => {
      return API.DELETE("/handle/monitor/logininfor/" + ids)
    },
    // 登录日志清空接口
    cleanLogininfor: params => {
      return API.DELETE("/handle/monitor/logininfor/clean")
    },
      //登录导出日志
    exportLoginLogUrl: params => {
        return (
          `${base}/handle/monitor/logininfor/export?` +
          Object.keys(params)
          .map(key => key + "=" + encodeURIComponent(params[key]))
          .join("&")
        );
    },
    /*===============================================end 系统运行日志 =========================*/

    //上传设备模板
    uploadDeviceFile: () => {
        return `${base}/handle/platformDevDevice/upload`;
    },
    //上传网关数据
    uploadModuleFile: () => {
        return `${base}/handle/v1/platformMduModule/upload`;
    },

    //离线网关
    disconnectModule: params => {
        return API.POST(
            `/handle/v1/platformMduModule/disconnect/${params.commuType}/${params.moduleCode}/${params.id}`,
            params
        );
    }
};


// WEBPACK FOOTER //
// ./src/api/api.js